module.exports = __webpack_public_path__ + "static/media/animated-coupon.3b8a16d2.gif";